<template>
  <footer>
    <div class="container">
      <div class="row main-link-section">
        <div
          class="col-6 col-md-3"
          v-for="(section, i) in footerLinkSections"
          :key="'section-' + i"
        >
          <p v-if="i === 3" class="header-small">Contact Us</p>
          <ul class="list-unstyled">
            <li v-for="(link, x) in section" :key="'link-' + x">
              <router-link
                class="link"
                :class="[(i === 2) | (i === 3) ? 'link-small' : '']"
                :to="link.url"
              >
                {{ link.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="row bottom-link-section">
        <div class="col-12 col-md-3">
          <ul class="links-social list-unstyled list-inline">
            <li class="list-inline-item">
              <a href=""><icon-youtube /></a>
            </li>
            <li class="list-inline-item">
              <a href=""><icon-twitter /></a>
            </li>
            <li class="list-inline-item">
              <a href=""><icon-facebook /></a>
            </li>
            <li class="list-inline-item">
              <a href=""><icon-instagram /></a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-7 legal-link-section">
          <ul class="list-inline">
            <li
              class="list-inline-item"
              v-for="(link, i) in footerLegalLinks"
              :key="'legal-links-' + i"
            >
              <router-link :to="link.url" v-html="link.name"></router-link>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-2 country-link-section">
          <router-link :to="'/'"
            ><icon-country-flag class="flag" />United States</router-link
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import IconYoutube from "@/components/icons/icon-youtube";
import IconTwitter from "@/components/icons/icon-twitter";
import IconFacebook from "@/components/icons/icon-facebook";
import IconInstagram from "@/components/icons/icon-instagram";
import IconCountryFlag from "@/components/icons/icon-country-flag";
export default {
  name: "mainFooter",
  components: {
    IconInstagram,
    IconFacebook,
    IconTwitter,
    IconYoutube,
    IconCountryFlag,
  },
  computed: {
    footerLinkSections() {
      return this.$store.state.footer.mainLinks;
    },
    footerLegalLinks() {
      return this.$store.state.footer.legal;
    },
  },
};
</script>

<style scoped lang="scss">
footer {
  padding-top: 90px;
  background: #ffffff;
}
.main-link-section {
  border-bottom: 1px solid #eee;
  .header-small {
    font-size: 13px;
    margin: 0;
    line-height: 50px;
    cursor: default;
  }
  .link {
    color: #000;
    font-size: 20px;
    line-height: 50px;
    &:hover,
    &-small:hover {
      text-decoration: none;
      text-shadow: 0 0 0 rgba(0, 0, 0, 1);
    }
    &-small {
      font-size: 13px;
    }
  }
}
.links-social li {
  margin-right: 50px;
  &:last-of-type {
    margin: 0;
  }
}
.bottom-link-section {
  margin-top: 34px;
  margin-bottom: 66px;
}
.legal-link-section a {
  font-size: 12px;
  color: #000;
}
.country-link-section {
  @media screen and (min-width: map-get($grid-breakpoints,lg)) {
    text-align: right;
  }
  .flag {
    margin-right: 14px;
  }
  a {
    font-size: 12px;
    color: #000;
  }
}
</style>
